import React from 'react'

const RefreshIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g stroke="#000" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19.715 9.368a8.421 8.421 0 1 1-7.369-4.21h3.158" />
                <path d="m12.346 8.316 3.158-3.158L12.346 2" />
            </g>
        </svg>

    )
}
export default RefreshIcon
